import 'whatwg-fetch';
import TagManagerService from 'services/TagManager';
import { api, jsonData } from 'config';
import CMSFactory from "factories/CMS";
import Moment from 'moment';
import fetchApi from 'services/Promise';
import StorageService from 'services/StorageService';

const apiUrlWp = api.proxy;

// PagesId CMS
const pageId = 56;
const pageIdOffers = 446;
const pageIdBenefits = 804;
const pageIdTerms = 917;
const pageIdFrequent = 1001;
const SecurityPrivacy = 1093;
const pageIdContest = 1104;
const pageIdProviders = 1659;
const pageIdOurServices = 1317;
const pageIdOperations = 8548;
const pageIdOperationsV2 = 18721;
const pageIdRegisterForm = 12677;

let countItem = 0;
let tagItem = [];
const tagPromotions = (cms) => {
    getDateTime().then(response => {
        if(!(cms && cms.acf && Array.isArray(cms.acf.content))) return false;
        let tagPromotionsBanner = [];
        let tagPromotionsShortBanner = [];
        let tagPromotionsSmallBanner = [];
        let index = 1;
        
        let datatime = response && response.datetime ? response.datetime : null;
        let serverDate = CMSFactory.milliseconds(datatime);

        cms.acf.banners && cms.acf.banners.map(item => {
            
            let startDate = CMSFactory.milliseconds(item.start_date);
            let endDate = CMSFactory.milliseconds(item.end_date);

            if (startDate && (startDate >= serverDate)) return;
            if (endDate && (endDate <= serverDate)) return;
            if (!item.active) return;

            if (window.innerWidth <= 760) {
                item.id = item.imagen_mobile ? item.imagen_mobile.split('/').pop() : '';
            } else {
                item.id = item.image ? item.image.split('/').pop() : '';
            }
            tagPromotionsBanner.push({
                id: item.id,
                name: item.title,
                creative: 'Banner Principal',
                position: 'slot' + index
            })
            index++;
        });

        index = 1;
        let countSM = 1;
        

        cms.acf.content.map(item => {

            if (item.acf_fc_layout)
                switch (item.acf_fc_layout) {
                    
                    case 'short_banner': {

                        let startDate = item.start_date ? CMSFactory.milliseconds(item.start_date) : '';
                        let endDate = item.end_date ? CMSFactory.milliseconds(item.end_date) : '';
                        if (startDate && (startDate >= serverDate)) return false;
                        if (endDate && (serverDate >= endDate)) return false;
                        if (!item.active) return false;

                        if (window.innerWidth <= 760) {
                            item.id = item.imagen_mobile ? item.imagen_mobile.split('/').pop() : '';
                        } else {
                            item.id = item.image ? item.image.split('/').pop() : '';
                        }

                        tagPromotionsShortBanner.push({
                            id: item.id,
                            name: item.title,
                            creative: 'Huincha ' + index,
                            position: 'slot' + index
                        });
                        index++;
                        break;
                    }
                    case 'small_banner': {
                        let index = 3 * (countSM - 1);

                        item.banners.map(val => {
                            let startDate = val.start_date ? CMSFactory.milliseconds(val.start_date) : '';
                            let endDate = val.end_date ? CMSFactory.milliseconds(val.end_date) : '';
                            if ((startDate && (startDate >= serverDate)) || (endDate && (endDate <= serverDate))) return;
                            if (window.innerWidth <= 760) {
                                val.id = val.imagen_mobile ? val.imagen_mobile.split('/').pop() : '';
                            } else {
                                val.id = val.image ? val.image.split('/').pop() : '';
                            }
                            if (val.active) {
                                index++;
                                tagPromotionsSmallBanner.push({
                                    id: val.id,
                                    name: val.title,
                                    creative: 'Promo-Secundaria',
                                    position: 'slot' + index
                                });
                            }
                        });

                        countSM++;
                        break;
                    }
                    case 'grid_image': {
                        
                        _gtmBanners(item.content.group_left);
                        _gtmBanners(item.content.group_right);
                    }
                }
        });

        if(tagPromotionsBanner.length){
            TagManagerService.promotionsImpressions(tagPromotionsBanner);
        }
            
        if(tagPromotionsShortBanner.length){
            TagManagerService.promotionsImpressions(tagPromotionsShortBanner);
        }

        if(tagPromotionsSmallBanner.length){
            TagManagerService.promotionsImpressions(tagPromotionsSmallBanner);
        }

        if(tagItem.length) {
            TagManagerService.promotionsImpressions(tagItem);
        }
    });
        
}

const _getSingleImageId = (data) => {
    let id = ''
    if (window.innerWidth <= 768) {
        id = data.image_mobile ? data.image_mobile.split('/').pop() : '';
    } else {
        const image = data.image || data.image_desktop;
        id = image ? image.split('/').pop() : '';
    }
    return id;
}

const _gtmDoubleImageId = (data, item) => {
    let id = '';
    if (window.innerWidth <= 768) {
        const imageMobile = data[`image_${item}`][`image_mobile`];
        id = imageMobile ? imageMobile.split('/').pop() : '';
    } else {
        const imageDesktop = data[`image_${item}`][`image_desktop`];
        id = imageDesktop ? imageDesktop.split('/').pop() : '';
    }
    return id;
}
const _gtmBanners = (data) => {
    
    data && data.map((item) => {
        let position;
        if(item.acf_fc_layout === 'double_image'){
            for (let j = 0; j < 2; j++) {
                const typeImage = j ? 'b' : 'a';
                item.id = _gtmDoubleImageId(item, typeImage),
                countItem++;
                position = countItem;
                item.title = item.title ? item.title : item.id;
                item[`position_${typeImage}`] = position;
                tagItem.push({
                    id: item.id,
                    name: item.title,
                    creative: 'Banner Sencudario Grid',
                    position: 'slot' + position
                });
            }
        } else {
            item.id = _getSingleImageId(item);
            countItem++;
            position = countItem;
            item.position = 'slot' + position;
            item.title = item.title ? item.title : item.id;
            tagItem.push({
                id: item.id,
                name: item.title,
                creative: 'Banner Secundario Grid',
                position: 'slot' + position
            })
        }
        return item;
    })
    return tagItem;  
}

const getHome = (id = pageId, cache = 'home', renderData = 'cms') => {
    const transformRenderData = data => {
        return  {
            acf: {
                content: data.content,
                banners: data["home-banner"],
                banner_info:  data['banner_info'],
                warning: data.warning
            },
            datetime: data.datetime
        }
    };

    return fetchApi.getJsonWithCache(`${jsonData.cms}/page-${id}.json`, cache, renderData, transformRenderData).then(results => {
        if (results) tagPromotions(results);
        return results;
    });
}

const getSchool = (id, cache) => {
    return fetchApi.getJsonWithCache(`${jsonData.cms}/page-${id}.json`, cache);
}

const getPage = (node, id) => {
    return fetchApi.getJsonWithCache(`${jsonData.cms}/page-${(node !== 'version') ? id : 16512}.json`, node, node);
}

const getMenu = (filterFixed = true) => {
    return getPage('menu', 11732).then(results=> {

        const fixedCategories = [];

        if(!(results && results.acf && results.acf.items && results.acf.items.length)){
            return {
                acf: {
                    items: [],
                    fixed_categories: []
                }
            };
        }

        let data = {...results.acf};

        const categoryFixes = data.fixed_categories.map(fixedCat => fixedCat.title);

        const departments = _selectActive(data.items).map(category => {
            let link = { ...category };

            if (categoryFixes.indexOf(link.title) !== -1) {
                fixedCategories.push(link);

                if(filterFixed){
                    return false;
                }
            }

            return link;

        }).filter((i) => i);

        const ordenfixedCategories = [];

        categoryFixes.map((category) => {
            if (fixedCategories.findIndex((val) => val.title === category) !== -1) {
                ordenfixedCategories.push(fixedCategories[fixedCategories.findIndex((val) => val.title === category)]);
            }
            return category;
        });

        data.items = departments;
        data.fixed_categories = ordenfixedCategories;

        return {
            acf: {
                items: data.items,
                fixed_categories: data.fixed_categories
            }
        }
    });
}

const _selectActive = (list) => {
    return list.filter(obj => {

        if(obj.items){
            obj.items = _selectActive(obj.items);
        }

        return obj.active === true;
    });
}

const getVersion = () => {
    return getPage('version')
}

const getPageTermsConditions = () => {
    return getPage('terms', pageIdTerms)
}

const getPageSecurityandPrivacy = () => {
    return getPage('security', SecurityPrivacy);
}

const getPageFrequentQuestions = () => {
    return getPage('faq', pageIdFrequent);
}

const getPageContest = () => {
    return getPage('contest', pageIdContest);
}

const getOffers = () => {
    return getPage('offer', pageIdOffers);
}

const getPageBenefits = () => {
    return getPage('benefits', pageIdBenefits);
}

const getOperations = () => {
    return getPage('operations', pageIdOperations).then(results => _getOperationsValue(results));
}
const getOperationsV2 = () => {
    return getPage('operationsV2', pageIdOperationsV2).then(results => _getOperationsValue(results));
}

const getPageOurServices = () => {
    return getPage('ourServices', pageIdOurServices);
}

const getFilesProviders = () => {
    return getPage('providers', pageIdProviders);
}

const getRegisterFormSchools = () => {
    return getPage('schoolsForm', pageIdRegisterForm);
}

const _getOperationsValue = (data) => {
    if(!(data && data.acf)){
        return data;
    }

    let results = {...data.acf};

    if(!(results.car && results.store && results.states)){
        return results;
    }

    results.car = results.car.map(item => {
        if(!item.active) return false;
        return {
            label: item.name,
            sc: item.sc,
            value: item.value
        }
    }).filter(Boolean);

    results.store = results.store.map(item => {
        if(!item.active) return false;
        return {
            label: item.name,
            sc: item.sc,
            value: item.value
        }
    }).filter(Boolean);

    results.states = results.states.map(item => {
        if(!item.active) return false;
        return {
            label: item.name,
            cities: item.cities,
            value: item.value
        }
    }).filter(Boolean);

    return results;
}

const validSCItem = (validation = null) => {

    try{
        let  sc = StorageService.getSecureItem('sales_channel');
        sc = sc ? parseInt(sc) : null;
        const salesChannels = (validation && validation.sc) ? validation.sc.trim().split(',') : null;

        if(sc){
            if((validation && validation.type == 'include') && (salesChannels && salesChannels.length && (salesChannels.findIndex(item => parseInt(item) === sc) === -1))){
                return false;
            }
            if((validation && validation.type == 'exclude') && (salesChannels && salesChannels.length && (salesChannels.findIndex(item => parseInt(item) === sc) !== -1))){
                return false;
            }
        }else{
            if(validation && (validation.type == 'include') && (salesChannels && salesChannels.length)){
                return false;
            }
        }

        return true
    }catch(e){
        /* eslint-disable no-console */
        console.log(e);
        /* eslint-enable no-console */
        return false
    }
}

const _getPostType = (path = '', type = 'category', renderName = null, retry = true) => {
    const url = `${jsonData.cms}/${path}.json`;
    renderName = renderName || type;

    if (window && window.__renderData && window.__renderData[renderName] && window.__renderData[renderName].length) {
        return new Promise(resolve => {
            const dataLanding = window.__renderData[renderName].filter(res => res.slug === path);
            delete window.__renderData[renderName];
            resolve(dataLanding);
        });
    }

    if(!retry) return fetchApi.getJson(url);

    return fetchApi.retry(() => fetchApi.getJson(url));
}

const getPostType = (slug, type) => {
    return _getPostType(slug, type);
}

const getLanding = (path = '') => {
    return _getPostType(path, 'offers', 'landing');
}

const getBanner = (path = '', type = 'category') => {
    if(path === '') return Promise.resolve([]);
    return _getListBanner(path, type).then(category => {
        if(!category) return [];
        return _getPostType(path, type, null, false);
    })
}

const _getListBanner = (path, type) => {
    return fetchApi.getJsonWithCache(`${jsonData.cms}/list-${type}.json`, 'list-' + type).then(data => {
        return data.indexOf(path) !== -1;
    });
}

let _datetime = null;

const getDateTime = () => {
    if (_datetime) {
        return Promise.resolve(_datetime);
    }

    return fetchApi.retry(() => fetchApi.get(apiUrlWp + `/cms/datetime`))
        .then(results => {
            if (!results || (results.status && results.message)) {
                return false;
            }
            return results;
        })
        .then(result => {
            if (!result) return false;

            const dateTime = Moment(result.datetime).format();
            _datetime = { datetime: dateTime };
            return _datetime;
        }).catch(() => {
            _datetime = null;
            return false;
        });
}

const CmsService = {
    getHome,
    getSchool,
    getPage,
    getMenu,
    getVersion,
    getPageTermsConditions,
    getPageSecurityandPrivacy,
    getPageFrequentQuestions,
    getPageContest,
    getOffers,
    getPageBenefits,
    getOperations,
    getPageOurServices,
    getFilesProviders,
    getRegisterFormSchools,
    getPostType,
    getLanding,
    getBanner,
    getDateTime,
    validSCItem,
    getOperationsV2
}

export default CmsService;
